import { useInfiniteQuery } from '@tanstack/react-query'
import { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { QUERY_KEY } from '../../../constants'

import { StoresContext } from '../../../provider/StoreProvider'

import { getNoticeList } from '../../../api/notice'

import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { CenterWrap } from '../../../components/common'
import { Header } from '../../../components/header'
import { DivideLine } from '../../../components/divide'
import { Spinner } from '../../../components/spinner/Spinner'
import { EmptyPage } from '../../../components/exception/EmptyPage'
import { InfinityScroll } from '../../../components/pagingList/InfinityScroll'
import { NotificationList, NotificationItem } from '../../notification/components/List'

export function NoticeList() {
  const {
    commonStore: { setShowTab },
  } = useContext(StoresContext)

  const { data, isPending, isError, hasNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: [QUERY_KEY.noticeList],
    queryFn: async ({ pageParam = 0 }) => await getNoticeList({ offset: pageParam, size: 50 }),
    getNextPageParam: (lastPage) => (lastPage.last ? undefined : lastPage.offset + lastPage.size),
    initialPageParam: 0,
    select: (data) => ({
      ...data,
      pages: data.pages.map((page) => page.list).flat(),
    }),
  })

  useEffect(() => {
    setShowTab(false)
  }, [])

  if (isPending) {
    return (
      <Wrap>
        <Header type="SUB" title="공지사항" />
        <CenterWrap>
          <Spinner />
        </CenterWrap>
      </Wrap>
    )
  }

  if (isError || !data.pages.length) {
    return (
      <Wrap>
        <Header type="SUB" title="공지사항" />
        <EmptyPage content="조회 가능한 공지사항이 없습니다." />
      </Wrap>
    )
  }

  return (
    <Wrap>
      <Header type="SUB" title="공지사항" />
      <StyledContent id="infinity-scroll-target">
        <InfinityScroll length={data.pages.length} isLast={!hasNextPage} next={fetchNextPage}>
          <NotificationList>
            {data.pages.map(({ id, title, createdDate }) => (
              <Link key={id} to={`/notice/${id}`}>
                <NotificationItem>
                  <NotificationItem.Title>{title ?? ''}</NotificationItem.Title>
                  <NotificationItem.Date>{createdDate ?? ''}</NotificationItem.Date>
                </NotificationItem>
                <DivideLine />
              </Link>
            ))}
          </NotificationList>
        </InfinityScroll>
      </StyledContent>
    </Wrap>
  )
}

const StyledContent = styled(Content)`
  padding-top: 8px;
`
